import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "network-home"
};
const _hoisted_2 = {
  key: 0,
  class: "content-section"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  id: "plans",
  class: "plans-section"
};
const _hoisted_5 = {
  key: 0,
  class: "try-search-card"
};
const _hoisted_6 = {
  class: "topbar-search"
};
const _hoisted_7 = {
  class: "section-heading"
};
const _hoisted_8 = {
  class: "events-section"
};
const _hoisted_9 = {
  class: "events-card"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_button = _resolveComponent("b-button");
  const _component_SubscriptionTypes = _resolveComponent("SubscriptionTypes");
  const _component_StreamList = _resolveComponent("StreamList");
  const _component_b_container = _resolveComponent("b-container");
  const _component_Login = _resolveComponent("Login");
  return $data.networkInfo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_container, {
    class: "home-shell"
  }, {
    default: _withCtx(() => [$data.content ? (_openBlock(), _createElementBlock("section", _hoisted_2, [_createElementVNode("div", {
      class: "content-card",
      innerHTML: $data.content
    }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_4, [!$options.isLoggedIn ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "try-search-copy"
    }, [_createElementVNode("span", {
      class: "try-search-eyebrow"
    }, "Not sure yet?"), _createElementVNode("h3", null, "See what's on before you subscribe"), _createElementVNode("p", null, "Look up a school, ensemble, event or year to check that the performances you want are here.")], -1)), _createElementVNode("form", {
      class: "try-search-form",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.openNetworkSearch && $options.openNetworkSearch(...args), ["prevent"]))
    }, [_createElementVNode("div", _hoisted_6, [_cache[4] || (_cache[4] = _createElementVNode("span", {
      class: "search-icon"
    }, [_createElementVNode("svg", {
      width: "13",
      height: "13",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [_createElementVNode("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }), _createElementVNode("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    })])], -1)), _createVNode(_component_b_form_input, {
      modelValue: $data.trySearchText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.trySearchText = $event),
      size: "sm",
      placeholder: "Search Network",
      name: "text_search",
      autocomplete: "off",
      class: "topbar-search-input"
    }, null, 8, ["modelValue"])]), _createVNode(_component_b_button, {
      type: "submit",
      class: "try-search-btn",
      disabled: !$data.trySearchText.trim().length
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Search ", -1)]))], undefined, true),
      _: 1
    }, 8, ["disabled"])], 32)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_cache[8] || (_cache[8] = _createElementVNode("h2", null, "Choose Your Plan", -1)), _createElementVNode("p", null, [_cache[7] || (_cache[7] = _createTextVNode(" Already have an account? ", -1)), _createElementVNode("a", {
      href: "",
      onClick: _cache[2] || (_cache[2] = _withModifiers($event => $data.showLoginModal = true, ["prevent"]))
    }, "Log in here")])]), _createVNode(_component_SubscriptionTypes, {
      types: $data.networkInfo.subscriptiontypes
    }, null, 8, ["types"])]), _createElementVNode("section", _hoisted_8, [_cache[9] || (_cache[9] = _createElementVNode("div", {
      class: "section-heading"
    }, [_createElementVNode("h2", null, "Scheduled Events"), _createElementVNode("p", null, "Browse upcoming livestreams and premieres.")], -1)), _createElementVNode("div", _hoisted_9, [_createVNode(_component_StreamList, {
      showNoResults: "",
      showloading: ""
    })])])], undefined, true),
    _: 1
  }), _createVNode(_component_Login, {
    show: $data.showLoginModal,
    onClose: _cache[3] || (_cache[3] = $event => $data.showLoginModal = false)
  }, null, 8, ["show"])])) : _createCommentVNode("", true);
}